var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('SchedulerModal',{attrs:{"showScheduler":_vm.showScheduler,"toggleScheduler":_vm.toggleScheduler}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }